import { isEmpty, isNil } from "ramda";

export const isValidToken = (accessToken: string | undefined): boolean => {
  if (isNil(accessToken) || isEmpty(accessToken)) {
    return false;
  }
  return true;
};
